import { NgModule } from '@angular/core';
import { FiToggleVisibilityDirective } from './toggle-visibility.directive';

@NgModule({
    declarations: [FiToggleVisibilityDirective],
    exports: [FiToggleVisibilityDirective],
})
export class FiToggleVisibilityModule {}
